import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user : JSON.parse(localStorage.getItem('user'))
  },
  getters : {
    USER : state => {
      return state.user
    }
  },
  mutations: {
    SET_USER : (state, payload) => {
      state.user = payload
    },
  },
  actions:{
    SAVE_USER : async (context, payload) => {
      console.log('store actions ' + payload)
      context.commit('SET_USER', payload)
    },
    REMOVE_USER : async (context, payload) => {
      console.log('store actions ' + payload)
      context.commit('SET_USER', null)
    }
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js